import { render } from "./gzhOAList.vue?vue&type=template&id=b45c8cdc"
import script from "./gzhOAList.vue?vue&type=script&lang=js"
export * from "./gzhOAList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__